import React from 'react'
import { withStyles, Backdrop } from '@material-ui/core';
import PropTypes from 'prop-types';
import Loading from '../../Loading';
import clsx from 'clsx';

const style = theme => ({
	root: {
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: theme.zIndex.modal,
		position: 'fixed',
	},
})

function LoadingScreen({
						   classes,
						   open = true,
					   }) {
	return (
		<div className={clsx({
			[classes.root]: open
		})}>
			<Backdrop open={open} />
			{open && <Loading size={100} />}
		</div>
	)
}

LoadingScreen.propTypes = {
	classes: PropTypes.any,
}

LoadingScreen.defaultProps = {
}

export default withStyles(style)(LoadingScreen);